import image1 from '../../../../assets/images/work/certifire/Certifire_detailed_img_1.jpg';
import image2 from '../../../../assets/images/work/certifire/Certifire_detailed_img_2.jpg';
import image4 from '../../../../assets/images/work/certifire/Certifire_detailed_abovefooter.jpg';

import artwork from '../../../../assets/images/art_2.png';
import eoLogoLowJpg from '../../../../assets/images/eologo-low.jpg';
import eoLogoJpg from '../../../../assets/images/eologo.jpg';

const Data_CertiFire = {
  content: (
    <>
      {/* PROBLEM + CHALLENGES */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                {/* PROBLEM */}
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">PROBLEM</h4>

                  <div className="paragraph light-1">
                    <p>
                      Delivering hands-on fire alarm technician training is challenging—particularly for remote learners in
                      the Certi-Fire program. In-person lab environments are essential for certification, yet access,
                      scheduling, safety, and resource constraints often limit meaningful practice time.

                      Certi-Fire VR was developed to replicate and enhance lab-based learning in a safe virtual environment,
                      giving trainees the opportunity to build practical skills without the risks or costs associated with
                      live electrical work.
                    </p>
                  </div><br/>
                </div>

                {/* CHALLENGES */}
                <div className="col-lg-6 second-column">
                  <h4 className="heading heading-small light-2">CHALLENGES</h4>

                  <div className="paragraph light-1">
                    <p>
                      The primary challenge was ensuring the virtual experience accurately reflected real-world technician
                      tasks. Electrical systems needed to behave correctly, tools had to function realistically, and the
                      environment had to support both guided instruction and independent learning.
                      Achieving this required close collaboration with industry partners, rapid iteration, and extensive
                      testing with subject matter experts.
                    </p>
                  </div>

                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PROJECT CONTENT */}
      <div className="project-content">
        <div className="project-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-large dark-1">
                    A virtual training environment that delivers real-world fire alarm technician skills—without real-world
                    risk.
                  </h2>

                  <div className="paragraph dark-1">
                    <p>
                      Certi-Fire VR is a virtual training solution developed by NORCAT in partnership with the Electrical
                      Contractors Association of Ontario (ECAO). Designed to support both remote and in-class learners, the
                      experience replicates the lab-based training required for fire alarm technician certification.
              
                      Built for Meta’s Oculus platform, trainees can safely practice wiring systems, diagnosing faults, and
                      measuring electrical flow in a fully immersive environment.
                    </p>
                  </div>

                  <div className="heading heading-medium dark-1">
                    <p>Collaborative Development</p>
                  </div>

                  <div className="paragraph dark-1">
                    <p>
                      NORCAT worked closely with ECAO and the International Brotherhood of Electrical Workers (IBEW) to ensure
                      technical accuracy. Industry experts guided development through regular reviews, helping refine the
                      simulation from early prototypes to final deployment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image-wrapper">
            <div className="single-image">
              <img src={image1} alt="Certi-Fire VR environment" />
            </div>
            <div className="single-image">
              <img src={image2} alt="Certi-Fire VR tools and interaction" />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-medium dark-1">Innovation & Engagement</h2>

                  <div className="paragraph dark-1">
                    <p>
                      Certi-Fire VR features a sandbox-style learning environment where trainees can wire systems, troubleshoot
                      issues, and test circuits using realistic virtual tools—including a fully functional multimeter.
                      Networking capabilities allow instructors and students to connect in real time, supporting guided,
                      collaborative training sessions both on-site and remotely.
                    </p>
                  </div>

                  <div className="text-list medium dark-1">
                    <ul>
                      <li>• Non-linear, sandbox-style training environment</li>
                      <li>• Realistic electrical tools and testing workflows</li>
                      <li>• Instructor-led and collaborative learning sessions</li>
                      <li>• Scalable design for larger training cohorts</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image">
            <img src={image4} alt="Certi-Fire VR training session" />
          </div>
        </div>
      </div>

      {/* RESULTS */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">RESULTS</h4>

                  <div className="paragraph light-1">
  <p>
    Certi-Fire VR has been successfully deployed across training centres in Ontario, strengthening existing programs through
    safe, repeatable hands-on practice. The solution improves access to practical training for both remote and in-class
    learners while significantly reducing the risks associated with live electrical work and equipment damage.
  </p><br/>
  <p>
    By minimizing reliance on physical equipment and consumable materials, Certi-Fire VR also lowers operational costs and
    enables training providers to support larger cohorts more efficiently. Designed as a scalable solution, the program is
    now positioned for expansion beyond Ontario, extending its impact across additional training environments.
  </p>
</div>

                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="paragraph light-1">
                      <p>PC VR</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PARTNERS</h4>
                    <div className="paragraph light-1">
                      <p>
                      (ECAO) Electrical Contractors Association of Ontario, 
                        (IBEW) International Brotherhood of Electrical Workers
                      </p>
                    </div>
                  </div>

                  <div className="content-wrapper eo-acknowledgement">
                    <picture>
                      <source media="(max-width: 1024px)" srcSet={eoLogoLowJpg} />
                      <img className="eo-logo-primary" src={eoLogoJpg} alt="Employment Ontario logo" />
                    </picture>
                    <p>
                      This{' '}
                      <a href="https://www.ontario.ca/page/employment-ontario" target="_blank" rel="noreferrer">
                        Employment Ontario
                      </a>{' '}
                      initiative is funded in part by the{' '}
                      <a href="https://www.canada.ca/en.html" target="_blank" rel="noreferrer">
                        Government of Canada
                      </a>{' '}
                      and the{' '}
                      <a href="https://www.ontario.ca/page/government-ontario" target="_blank" rel="noreferrer">
                        Government of Ontario
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-content-footer">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-md-6">
                  <h3 className="heading heading-large light-1">
                    Have an idea?
                    <br />
                    Let’s explore it together.
                  </h3>
                </div>
                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                  <div className="button-wrapper">
                    <a className="button button-1" href="/Contact">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="artwork artwork-2">
            <img src={artwork} alt="artwork" />
          </div>
        </div>
      </div>
    </>
  ),
};

export default Data_CertiFire;


